export const TableNote = () => {
    return (
        <p className='text-danger fw-bold text-end' style={{marginBottom:"0.5em"}}>
            Note : Only todays date data will be Edit or Delete.
        </p>
    )
}